export const ERROR_CODE = {
  AUTHENTICATION_ERROR: 'AuthenticationError',
  AUTHENTICATION_REQUIRED: 'AuthenticationRequired',
  PERMISSION_DENIED: 'PermissionDenied',
  LIMIT_REACHED: 'limitReached',
  NO_QUESTIONS: 'noQuestions',
  NO_LIMIT_FOR_CC: 'noLimitForCC',
  SEND_BACK_PARTS: 'Release method is not allowed',
  REQUEST_HAS_BEEN_SENT_TO_APPROVER: 'requestHasBeenSentToApprover',
  NO_PICTURES_ARE_UPLOADED: 'OperationDenied',
};

export const  ERROR_MESSAGE = {
  LIMIT_REACHED: "Commercial decision limit reached.",
  REQUEST_HAS_BEEN_SENT_TO_APPROVER: 'Request has been sent to approver.',
  ACCESS_FORBIDDEN: "Access to job forbidden.",
  NOT_FOUND: "Job not found.",
  JOB_LOCKED: "Job is locked.",
  NO_QUESTIONS: "No questions available for product family.",
  NO_LIMIT_FOR_CC: "User does not have commercial limit set for this customer center.",
  SEND_BACK_PARTS: "release method is not allowed.",
  NO_PICTURES_ARE_UPLOADED: 'No pictures are uploaded.',
  RATE_DECISION_HAS_TO_BE_DIFFERENT: 'Rate decision has to be different than the old one.',
}



// WEBPACK FOOTER //
// ./src/constants/errorCodes.js